const Backbone = require('backbone');
const Mn = require('backbone.marionette');
require('backbone.stickit');
const OAuthClient = require('jiji/domain/entity/oauth/client');
const API = require('jiji/infra/api/admin');
const Template = require('jiji/ui/template/content/admin/oauth/index.hbs');
const ItemTemplate = require('jiji/ui/template/content/admin/oauth/item.hbs');
const CreateTemplate = require('jiji/ui/template/content/admin/oauth/create.hbs');
const OAuthClientRepository = require('jiji/domain/repository/oauth/client');

const OAuthClientCreateView = Mn.View.extend({
    template: CreateTemplate,
    bindings: {
        '.id': 'id',
        '.secret': 'secret',
        '.redirectURI': 'redirectURI',
    },
    ui: {
        saveButton: '.save'
    },
    events: {
        'click @ui.saveButton': 'save'
    },

    onRender: function() {
        this.disable();
        this.listenTo(this.model, 'change', this.enable);
        this.stickit();
    },

    enable: function() {
        this.ui.saveButton.removeClass('disabled');
    },

    disable: function() {
        this.ui.saveButton.addClass('disabled');
    },

    save: function() {
        this.disable();
        OAuthClientRepository.createOAuthClient(this.model).then(() => {
            this.model = new OAuthClient();
            this.render();
        });
    }
});

const OAuthClientItemView = Mn.View.extend({
    template: ItemTemplate,
    tagName: 'li',
    className: 'collection-item',
    bindings: {
        '.id': 'id',
        '.secret': 'secret',
        '.redirectURI': {
            observe: 'redirectURI',
            onGet: function(value) {
                return value.replace(/,/g, '\r\n');
            },
            onSet: function(val) {
                return val.trim().replace(/\r\n/g, ',').replace(/\r/g, ',').replace(/\n/g, ',');
            }
        },
    },
    ui: {
        saveButton: '.save',
        deleteButton: '.delete'
    },
    events: {
        'click @ui.saveButton': 'save',
        'click @ui.deleteButton': 'delete'
    },

    onRender: function() {
        this.disable();
        this.listenTo(this.model, 'change', this.enable);
        this.stickit();
    },

    onDomRefresh: function() {
        Materialize.updateTextFields();
    },

    enable: function() {
        this.ui.saveButton.removeClass('disabled');
    },

    disable: function() {
        this.ui.saveButton.addClass('disabled');
    },

    save: function() {
        this.disable();
        OAuthClientRepository.updateOAuthClient(this.model).then(() => {
            this.disable();
        });
    },

    delete: function() {
        this.disable();
        OAuthClientRepository.deleteOAuthClient(this.model);
    }
});

const OAuthClientListView = Mn.CollectionView.extend({
    childView: OAuthClientItemView,
    tagName: 'ul',
    className: 'collection'
});

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        'clients': '.clients',
        'create': '.create'
    },

    onRender: function() {
        OAuthClientRepository.getOAuthClients().then(collection => {
            this.showChildView('clients', new OAuthClientListView({
                collection: collection
            }))
        });
        this.showChildView('create', new OAuthClientCreateView({
            model: new OAuthClient()
        }))
    }
});



// WEBPACK FOOTER //
// ./jiji/ui/view/content/admin/oauth/index.js